<button class='back-to-list' mat-stroked-button (click)="onCloseClick()">Back to list<mat-icon>arrow_forward</mat-icon></button>
<h2> {{ from.contact.names.name.first }} - Document Your Relationships....</h2>

@if (attendees?.length > 0) {
  <span>
    <button mat-flat-button class="btn" (click)="selectPersonFromAttendees()" >Fill From List</button>
  </span>
}
@if (isAdmin()) {
  <span>
    <button mat-flat-button class="btn" (click)="selectPerson()" >Fill From Select</button> <hr>
  </span>
}
<form [formGroup]="RelateForm" (ngSubmit)="submitRelateForm()" class="relate-form">


  <mat-form-field appearance="outline">
    <mat-label>First Name </mat-label>
    <input matInput  formControlName="firstName" required />
  </mat-form-field>
  <mat-form-field appearance="outline" >
    <mat-label>Last Name </mat-label>
    <input matInput  formControlName="lastName" required />
  </mat-form-field><br />
  <mat-form-field appearance="outline"  >
    <mat-label>Email</mat-label>
    <input formControlName="email" type="text" placeholder="Enter Email if Known" matInput >
  </mat-form-field>
  <br />
  <mat-form-field appearance="outline">
    <mat-label>Relation (IS MY)</mat-label>
    <mat-select matNativeControl  formControlName="relationType" required>
      @for (reltype of relations; track reltype) {
        <mat-option [value]="reltype">
          {{ reltype }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  &nbsp;

  <mat-form-field appearance="outline" >
    <mat-label>Natural Number?</mat-label>
    <mat-select matNativeControl  formControlName="nnGuess" >
      @for (nnI of nnKeys; track nnI) {
        <mat-option [value]="nnI">
          {{ nnI }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <br />
  &nbsp;
  @if (isAdmin()) {
    <span >
      <mat-form-field appearance="outline" >
        <mat-label>How Identified</mat-label>
        <mat-select matNativeControl  formControlName="sourceType">
          @for (nns of nnSources; track nns) {
            <mat-option [value]="nns">
              {{ nns }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </span>
  }
  &nbsp;
  <mat-form-field appearance="outline" >
    <mat-label>Birth Order (Birth Mother)</mat-label>
    <input matInput  formControlName="momBirthOrder" />
  </mat-form-field>


  <button mat-button type="submit" [disabled]="disableBtn" class="btn btn-save mat-submit-button">Submit</button>

</form>
